import { ApolloProvider } from '@apollo/client';
import { browserClient } from '@application/apollo';
import { App } from '@application/components';
import { initializeFirebase } from '@application/firebase';
import { initI18n } from '@application/i18n';
import { authState } from '@application/state';
import { HelmetProvider } from 'react-helmet-async';
import { useSSR, useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

setTimeout(() => {
  if (typeof window === 'undefined') return;

  // initializeDatadogRum();
  initializeFirebase();
}, 0);

export const ClientApp = () => {
  const { initialI18nStore, initialLanguage, apolloState, initialAuthState } = window;
  initI18n(initialLanguage);
  useSSR(initialI18nStore, initialLanguage);
  const { t: translate } = useTranslation();

  const client = browserClient({
    apolloState,
    token: initialAuthState.token,
    translate,
  });

  return (
    <HelmetProvider>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <RecoilRoot
            initializeState={({ set }) => {
              set(authState, initialAuthState);
            }}
          >
            <App />
          </RecoilRoot>
        </BrowserRouter>
      </ApolloProvider>
    </HelmetProvider>
  );
};
